//loading.js
export const LOADING_UPDATE = 'LOADING_UPDATE'

//colors.js
export const FETCH_COLORS = 'FETCH_COLORS'
export const ADD_COLOR = 'ADD_COLOR'
export const CLEAR_COLORS = 'CLEAR_COLORS'
export const ADD_COLOR_TYPE = 'ADD_COLOR_TYPE'
export const UPDATE_COLOR = 'UPDATE_COLOR'
export const DELETE_COLOR = 'DELETE_COLOR'
export const DETACH_COLOR = 'DETACH_COLOR'
export const DELETE_COLOR_TYPE = 'DELETE_COLOR_TYPE'
export const UPDATE_COLOR_TYPE = 'UPDATE_COLOR_TYPE'

//drags.js
export const SET_DRAG_DATA = 'SET_DRAG_DATA'
export const SET_DRAG_DATA_SRC = 'SET_DRAG_DATA_SRC'
export const ADD_LEFT_DRAG = 'ADD_LEFT_DRAG'
export const UPDATE_LEFT_DRAG = 'UPDATE_LEFT_DRAG'
export const DELETE_LEFT_DRAG = 'DELETE_LEFT_DRAG'
export const DETACH_LEFT_DRAG = 'DETACH_LEFT_DRAG'
export const FETCH_LEFT_DRAG = 'FETCH_LEFT_DRAG'
export const ADD_RIGHT_DRAG = 'ADD_RIGHT_DRAG'
export const DELETE_RIGHT_DRAG = 'DELETE_RIGHT_DRAG'
export const UPDATE_RIGHT_DRAG = 'UPDATE_RIGHT_DRAG'
export const CLEAR_DRAG_FORM = 'CLEAR_DRAG_FORM'

//sizes.js
export const FETCH_SIZES = 'FETCH_SIZES'
export const ADD_SIZE_TYPE = 'ADD_SIZE_TYPE'
export const UPDATE_SIZE = 'UPDATE_SIZE'
export const DELETE_SIZE = 'DELETE_SIZE'
export const DETACH_SIZE = 'DETACH_SIZE'
export const DELETE_SIZE_TYPE = 'DELETE_SIZE_TYPE'
export const ADD_SIZE = 'ADD_SIZE'
export const UPDATE_SIZE_TYPE = 'UPDATE_SIZE_TYPE'

//patterns.js
export const FETCH_PATTERNS = 'FETCH_PATTERNS'
export const UPDATE_PATTERN = 'UPDATE_PATTERN'
export const DELETE_PATTERN = 'DELETE_PATTERN'
export const DETACH_PATTERN = 'DETACH_PATTERN'
export const ADD_PATTERN = 'ADD_PATTERN'

//product.js
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FETCH_PRODUCTS_ALL = 'FETCH_PRODUCT_ALL'
export const UPDATE_PRODUCT_PAGINATE = 'UPDATE_PRODUCT_PAGINATE'
export const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS'
export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const FETCH_PRODUCT_ITEMS = 'FETCH_PRODUCT_ITEMS'
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const DELETE_PRODUCT = 'DELETE_PRODUCT'
export const UPDATE_PRODUCT_COLOR_PAGINATE = 'UPDATE_PRODUCT_COLOR_PAGINATE'
export const UPDATE_PRODUCT_SIZE_PAGINATE = 'UPDATE_PRODUCT_SIZE_PAGINATE'
export const UPDATE_PRODUCT_ITEM_PAGINATE = 'UPDATE_PRODUCT_ITEM_PAGINATE'
export const UPDATE_PRODUCT_COLORS = 'UPDATE_PRODUCT_COLORS'
export const UPDATE_PRODUCT_SIZE = 'UPDATE_PRODUCT_SIZE'
export const UPDATE_PRODUCT_ITEM = 'UPDATE_PRODUCT_ITEM'
export const SET_PRODUCT_ITEM = 'SET_PRODUCT_ITEM'
export const CLEAR_PRODUCT = 'CLEAR_PRODUCT'
export const FETCH_PRODUCT_COLORS = 'FETCH_PRODUCT_COLORS'
export const UPDATE_ICON_MASTERS = 'UPDATE_ICON_MASTERS'

//categories.js
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES'
export const ADD_CATEGORIES = 'ADD_CATEGORIES'
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY'
export const MOVE_CATEGORY = 'MOVE_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
export const CLEAR_CATEGORY = 'CLEAR_CATEGORY'
export const ADD_CHILD_CATEGORY = 'ADD_CHILD_CATEGORY'
export const HIERARCHY_UP_CATEGORY = 'HIERARCHY_UP_CATEGORY'

//items.js
export const FETCH_ITEMS = 'FETCH_ITEMS'
export const UPDATE_ITEMS_PAGINATE = 'UPDATE_ITEMS_PAGINATE'

//news.js
export const FETCH_NEWS_LIST = 'FETCH_NEWS_LIST'
export const FETCH_NEWS = 'FETCH_NEWS'
export const CLEAR_NEWS = 'CLEAR_NEWS'
export const UPDATE_NEWS = 'UPDATE_NEWS'

//professionals.js
export const FETCH_PROFESSIONALS = 'FETCH_PROFESSIONALS'
export const UPDATE_PROFESSIONAL = 'UPDATE_PROFESSIONAL'
export const DELETE_PROFESSIONAL = 'DELETE_PROFESSIONAL'

//collections.js
export const FETCH_COLLECTIONS = 'FETCH_COLLECTIONS'

//collectionItems.js
export const FETCH_COLLECTION_ITEMS = 'FETCH_COLLECTION_ITEMS'

//itemSelect.js
export const FETCH_ITEM_SELECT = 'FETCH_ITEM_SELECT'

//collectionTableSetItems.js
export const FETCH_COLLECTION_TABLE_SET_ITEMS = 'FETCH_COLLECTION_TABLE_SET_ITEMS'

//tableSets.js
export const FETCH_TABLE_SETS = 'FETCH_TABLE_SETS'

//collectionTableSets.js
export const FETCH_COLLECTION_TABLE_SETS = 'FETCH_COLLECTION_TABLE_SETS'
export const CLEAR_COLLECTION_TABLE_SET_ITEMS = 'CLEAR_COLLECTION_TABLE_SET_ITEMS'

//auth.js
export const AUTH_SAVE_TOKEN = 'AUTH_SAVE_TOKEN'
export const AUTH_FETCH_USER = 'AUTH_FETCH_USER'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_CLEAR = 'AUTH_CLEAR'

//orders.js
export const FETCH_ORDERS = 'FETCH_ORDERS'
export const UPDATE_ORDERS_PAGINATE = 'UPDATE_ORDERS_PAGINATE'
export const FETCH_ADMIN_ORDER = 'FETCH_ADMIN_ORDER'
export const UPDATE_ADMIN_ORDER = 'UPDATE_ADMIN_ORDER'

//coupons.js
export const FETCH_COUPON = 'FETCH_COUPON'
export const DELETE_COUPON = 'DELETE_COUPON'
export const FETCH_COUPONS = 'FETCH_COUPONS'
export const UPDATE_COUPONS_PAGINATE = 'UPDATE_COUPONS_PAGINATE'

//users.js
export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_USER = 'FETCH_USER'
export const UPDATE_USERS_PAGINATE = 'UPDATE_USERS_PAGINATE'
export const UPDATE_USER_ADDRESSES = 'UPDATE_USER_ADDRESSES'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_TYPE_LIST = 'UPDATE_USER_TYPE_LIST'

//galleries.js
export const FETCH_GALLERIES = 'FETCH_GALLERIES'
export const UPDATE_GALLERIES_PAGINATE = 'UPDATE_GALLERIES_PAGINATE'
export const ADD_GALLERY = 'ADD_GALLERY'
export const UPDATE_GALLERY = 'UPDATE_GALLERY'
export const DELETE_GALLERY = 'DELETE_GALLERY'

//tags.js
export const FETCH_ADMIN_TAG_LIST = 'FETCH_ADMIN_TAG_LIST'
export const UPDATE_TAG_LIST = 'UPDATE_TAG_LIST'
export const UPDATE_TAG_LIST_PAGINATE = 'UPDATE_TAG_LIST_PAGINATE'



// WEBPACK FOOTER //
// ./resources/assets/js/store/types/actions.js